import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {useGetUserQuery} from '@dms/api/customer';
import {getUserName} from '@dms/shared';
import {ReadOnlyField} from '@dms/shared-aftersales';

import {Nullish} from 'shared/web';

interface UserReadOnlyFieldProps {
  label: string;
  userId: string | Nullish;
}

export function UserReadOnlyField(props: UserReadOnlyFieldProps) {
  const userQuery = useGetUserQuery(isNotNil(props.userId) ? {id: props.userId} : skipToken);

  return <ReadOnlyField label={props.label} value={getUserName(userQuery.data)} />;
}
